module.exports = __webpack_public_path__ + "img/teamwork-icon-12.c08d7ca4.png";